// src/utils/formatters.js

/**
 * Converts a raw value (assumed in milli-sats) to sats.
 * @param {number} value Value in milli-sats.
 * @returns {number} Value in sats.
 */
export function transformToSats(value) {
    if (typeof value !== 'number' || isNaN(value)) return 0;
    return value / 1000;
}

/**
 * Formats large numbers with metric suffixes (K, M, B).
 * @param {number} n The number to format.
 * @returns {string} Formatted number string.
 */
export function formatNumber(n) {
    if (typeof n !== 'number' || isNaN(n)) return '0';
    if (n < 1e3) return n.toString();
    if (n < 1e6) return (n / 1e3).toFixed(2) + "K";
    if (n < 1e9) return (n / 1e6).toFixed(2) + "M";
    return (n / 1e9).toFixed(2) + "B";
}

/**
 * Displays a value (assumed in milli-sats) as either SATS or BTC,
 * applying formatting and appropriate units.
 * @param {number} value Value in milli-sats.
 * @returns {string} Formatted string with units (SATS or BTC).
 */
export function displayBTCOrSats(value) {
    const sats = transformToSats(value);
    // Use 100,000 sats as the threshold (0.001 BTC)
    if (sats >= 100000) {
        const btc = sats / 100_000_000; // 1 BTC = 100,000,000 sats
        return `${formatNumber(btc)} BTC`;
    } else {
        return `${formatNumber(sats)} SATS`;
    }
}